import { tv } from 'tailwind-variants'

export const backOldVersionVariants = tv({
  slots: {
    container: 'flex w-full justify-between ml-deca mr-deca',
    modalContainer: 'w-[50vw] h-[50vh] flex overflow-y-auto',
    returnMessage: 'flex items-center gap-1 align-center',
    buttonText: 'text-base underline cursor-pointer font-bold',
    textBase: 'text-base',
    textQuestion: 'text-base font-bold'
  }
})
